import $api from "@/http";
import next_api from "@/http/next_api";
import { Customer } from "@/types/customer-type";
import { create } from "zustand";

type LoginResponse = { user?: Customer, accessToken?: string }

/** Filter out null/invalid entries from fee arrays so [null] becomes [] and UI does not break */
function normalizeFeeArrays(customer: Customer | undefined | null): Customer | undefined | null {
    if (!customer) return customer;
    const filterValid = (arr: unknown[] | undefined) =>
        (arr || []).filter((f): f is Record<string, unknown> => f != null && typeof f === "object");
    return {
        ...customer,
        bank_fees: filterValid(customer.bank_fees as unknown[]),
        card_fees: filterValid(customer.card_fees as unknown[]),
        crypto_fees: filterValid(customer.crypto_fees as unknown[]),
        exchange_fees: filterValid(customer.exchange_fees as unknown[]),
    } as Customer;
}

interface ClientSettings {
    display?: {
        bankRequisitesAvailable?: boolean;
    };
    permissions?: {
        exchangeTabEnabled?: boolean;
        depositMethodsEnabled?: boolean;
        depositCardEnabled?: boolean;
        depositBankEnabled?: boolean;
        depositCryptoEnabled?: boolean;
        withdrawMethodsEnabled?: boolean;
        withdrawCardEnabled?: boolean;
        withdrawBankEnabled?: boolean;
        withdrawCryptoEnabled?: boolean;
        withdrawBalanceChoiceEnabled?: boolean;
        withdrawPendingFeeEnabled?: boolean;
        accountsTabEnabled?: boolean;
        changePasswordAllowed?: boolean;
        changePersonalDataAllowed?: boolean;
    };
    message?: string | null;
    footer_message?: string | null;
}

interface UserStore {
    user?: null | Customer 
    clientSettings?: ClientSettings
    isAuthed: any
    setUser: (user: Customer) => void
    logOutUser: () => void
    checkAuth: () => void
    setUserNull: () => void
}

export const useUser = create<UserStore>()((set, get) => ({
    user: undefined,
    clientSettings: undefined,
    isAuthed: () => {
        if (get().user !== undefined && get().user?.id) return true
        return false
    },    setUser: async (user: LoginResponse) => {
        if (user) {
            if (user.access_token && typeof window !== 'undefined') {
                localStorage.setItem("token", user.access_token)
            }
            const normalized = normalizeFeeArrays(user.user ?? undefined);
            if (typeof window !== 'undefined') {
                localStorage.setItem("user", JSON.stringify(user))
            }
            set((state) => ({
                user: normalized ?? undefined
            }))
        } else {
            set((state) => ({
                user: null
            }))
        }
    },    logOutUser: async () => {
        const user = await next_api.post("/logout")
        if (user) {
            if (typeof window !== 'undefined') {
                localStorage.removeItem("token")
                localStorage.removeItem("user")
            }
            set((state) => ({
                user: null
            }))
        }
    },
   checkAuth: async () => {
       try {
           const response = await $api.post("/refresh/customer")
           if (!response?.data?.customer?.id) {
               set((state) => ({
                   user: null,
                   clientSettings: undefined
                }))
            }
            if (response?.data?.access_token && typeof window !== 'undefined') {
                localStorage.setItem("token", response.data?.access_token)
            }
            if (response?.data?.customer && typeof window !== 'undefined') {
                const customer = normalizeFeeArrays(response.data.customer as Customer);
                localStorage.setItem("user", JSON.stringify(response.data.customer))
                set((state) => ({
                    user: customer ?? undefined,
                    clientSettings: response?.data?.client_settings
                }))
            }
        } catch (error) {
            set((state) => ({
                user: null,
                clientSettings: undefined
            }))
        }
    },
    setUserNull: () => {
        set((state) => ({
            user: null,
            clientSettings: undefined
        }))
    }
}))
